<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            light
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
        >
            <v-card tile>
                <v-toolbar
                    card
                    dark
                    class="teal"
                    :class="{'darken-2': !this.$vuetify.dark, 'darken-4': this.$vuetify.dark}"
                >
                    <v-toolbar-title>{{ $t("print") }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-sheet class="d-flex">
                    <v-card xs12 flat>
                        <v-card-text class="text-xs-center">
                            <v-layout row wrap style="height: 608px;">
                                <v-flex xs12 lg6>
                                    <h2 class="text-xs-left text-truncate pattern-name">{{ $t("pattern") }} &laquo;{{ selectedPattern.name }}&raquo;</h2>

                                    <div class="pattern-container mt-3">
                                        <div>
                                            <pattern-vue
                                                :pattern="pattern"
                                                :sizeNominal="sizeNominal"
                                                :falseCore="falseCore"
                                                :ellipseRatio="0"
                                                :rotate="0"
                                                :showDiameter="false"
                                                :showCross="false"
                                                :logDTop="logInfo.dTop"
                                                :logDBottom="logInfo.dBottom"
                                                :patternSolidBG="patternSolidBG"
                                                :rotatePattern="rotatePattern"
                                                sideSize="430"
                                                ref="PatternVue"
                                            />
                                        </div>
                                    </div>

                                    <div class="brief-info">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td><b>{{ $t("speciesAlt") }}:</b></td>
                                                    <td class="pl-2">{{ selectedPattern.speciesTranslated }}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>{{ $t("diameterU") }}:</b></td>
                                                    <td class="pl-2">{{ selectedPattern.Du }} {{ $t("cm")}}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>{{ $t("logLength") }}:</b></td>
                                                    <td class="pl-2">{{ logLength }}  {{ $t("m")}}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>{{ $t("curvature") }}:</b></td>
                                                    <td class="pl-2">{{ curvature[0] }} - {{ curvature[1] }}%</td>
                                                </tr>
                                                <tr>
                                                    <td><b>{{ $t("averageTaper") }}:</b></td>
                                                    <td class="pl-2"><template v-if="avgTaper !== null">{{ avgTaper }}</template><template v-else>{{ $t("auto") }}</template></td>
                                                </tr>
                                                <tr v-if="calcTimestamp">
                                                    <td><b>{{ $t("calculated") }}:</b></td>
                                                    <td class="pl-2">{{ calcTimestamp }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-flex>

                                <v-flex xs12 lg6 class="info">
                                    <v-sheet
                                        class="d-flex"
                                        xs12 lg6
                                    >
                                        <div class="chart-wrapper">
                                            <chart-vue :options="chartOptions" setTheme="light" class="chart" ref="Chart"></chart-vue>
                                        </div>
                                    </v-sheet>

                                    <v-sheet
                                        class="d-flex mt-2"
                                        xs12 lg6
                                    >
                                        <!--
                                        <table class="simple-data-table w-100" dense>
                                            <thead>
                                                <tr>
                                                    <th v-if="false">{{ $t("diameter") }}</th>
                                                    <th>{{ $t("boards") }}</th>
                                                    <th>{{ $t("amountShort") }}</th>
                                                    <th>{{ $t("logV") }}, {{ $t("m3")}}</th>
                                                    <th>{{ $t("boardsV") }}, {{ $t("m3")}}</th>
                                                    <th>{{ $t("output") }}, %</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(item, index) in tableData">
                                                    <tr
                                                        v-for="(subItem, subIndex) in item.dimensions"
                                                        :key="`${index}-${subIndex}`"
                                                    >

                                                        <td class="px-2">{{subItem}}</td>
                                                        <td class="text-xs-right px-2">{{item.amount[subIndex]}}</td>
                                                        <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.logV).toFixed(3)}}</td>
                                                        <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.boardsV).toFixed(3)}}</td>
                                                        <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.output).toFixed(1)}}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                        -->

                                        <template >
                                            <v-data-table
                                                :headers="tableHeader"
                                                :items="tableData"
                                                :rows-per-page-items="[100]"
                                                hide-actions
                                                class="dense-table"
                                            >
                                                <template v-slot:items="props">
                                                    <td>{{ props.item.size }}</td>
                                                    <td>{{ props.item.length }}</td>
                                                    <td>{{ props.item.qty }}</td>
                                                    <td>{{ props.item.volume }}</td>
                                                    <td>{{ props.item.percent ? props.item.percent + "%" : "" }}</td>
                                                </template>
                                            </v-data-table>
                                        </template>
                                    </v-sheet>
                                </v-flex>
                            </v-layout>

                        </v-card-text>
                    </v-card>
                </v-sheet>
                <div
                    class="footer"
                >
                    <pre>{{ $t("appName") }}   &#xa9; &laquo;{{ $t("avtomatikaVektor") }}&raquo;    https://a-vektor.ru</pre>
                    <span></span>
                </div>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    //import * as echarts from "echarts";
    import ChartVue   from "@/components/ChartVue";
    import PatternVue from "@/components/patterns/PatternVue";

    export default {
        name: "DiamPrintDialog",

        components: {
            ChartVue,
            PatternVue,
        },

        data() {
            return {
                dialog: false,
                chartOptions: {},
                diamsRange: [0, 0],
                pattern: {},
                sizeNominal: "1",
                falseCore: 0,
                output: 0,
                optimalDiam: 0,
                logInfo: {},
                logLength: 1,
                curvature: [0, 0],
                avgTaper: null,
                totalPrice: 0,
                calcTimestamp: null,
                tableHeader: [],
                calculatedData: [],
                selectedPattern: {},
                tableData: [],
                rotatePattern: false,
                patternSolidBG: false,
            }
        },

        watch: {
            dialog: function(val) {
                //this.$debug.log(this.logInfo);
                if (val == true) {
                    this.print();
                }
            },


        },

        computed: {
            showPatternInfo () {
                return (this.logInfo !== false);
            }
        },

        mounted () {
            let user = this.$store.getters.user;

            this.patternSolidBG = user.settings.patternSolidBG;
            this.rotatePattern  = user.settings.rotatePattern;
        },

        methods: {
            /**
             *  Вызов диалога печати
             */
            print () {
                setTimeout(() => {
                    window.print();
                    this.dialog      = false;
                    this.tableData   = [];
                    this.tableHeader = [];
                }, 800);
            },

        }
    };
</script>

<style lang="sass" scoped>
    .container.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 163px)

    .flex-card
        display: flex
        flex-direction: column

        .v-toolbar
            flex: 0

    .v-card__text
        padding: 6px

    .pattern
        width: 430px
        height: 430px

    .pattern-name
        max-width: 500px

    .pattern-container
        box-sizing: border-box
        border: 0 !important
        display: inline-block
        padding: 8px
        width: 450px
        height: 450px
        &>div
            margin-left: 10px
            margin-top: -15px

    .board *
        border-style: solid
        border-color: black !important

    .brief-info
        text-align: left !important
        height: 200px
        padding: 0 16px
        margin-top: -15px

    .chart-wrapper
        height: 280px
        width: 100%

    .data-table
        height: 300px
        table
            border-collapse: collapse
            th, td
                border: solid 1px #000

    .info-table
        border-width: 1px
        border-top: 0
        border-left: 0
        border-right: 0
        border-color: black
        border-style: solid
        margin: 0px !important
        padding-top: 6px !important
        padding-bottom: 6px !important
        td
            padding: 3px
            padding-right: 15px

    .info
        //border-width: 1px
        //border-color: black !important
        //border-style: solid
        background-color: #fff !important
        margin-left: 25px
        max-width: 450px
        //max-width: 45vw

    .footer
        text-align: center !important
        position: absolute
        left: 25px
        bottom: 5px

    .flex
        flex-basis: 50%
        align-self: center

    .transparent-bg
        background: transparent
</style>
